<div *ngIf="!isLoading">loading stopeed</div>
<div class="loader" *ngIf="isLoading">
    <mat-spinner
      [diameter]="50"
    ></mat-spinner>
  </div>